/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var RefundOutlineIcon = function RefundOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43993_364076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.05824 10.9687L4.16714 13.9396L1.1963 11.0485",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33747 17.5667C9.41183 20.694 14.4393 20.7369 17.5665 17.6625C20.6938 14.5881 20.7367 9.56071 17.6623 6.43343C14.588 3.30615 9.56054 3.26326 6.43327 6.33763C4.65447 8.08634 3.87357 10.4669 4.09664 12.7703",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6511 8.33256V7H10.9795V8.27836C10.1383 8.44375 9.42708 8.96937 9.13622 9.70203C8.64562 10.9378 9.52757 12.2625 11.0213 12.5334L12.6244 12.8241C13.0705 12.905 13.3724 13.2614 13.3231 13.6488C13.2694 14.0703 12.8222 14.3725 12.3299 14.3199L10.3071 14.1038C9.84909 14.0549 9.43138 14.3325 9.37413 14.724C9.31687 15.1154 9.64176 15.4724 10.0998 15.5213L10.9795 15.6153V17H12.6511V15.7473C13.8482 15.6639 14.8496 14.8649 14.9848 13.8034C15.127 12.6869 14.2569 11.6597 12.9714 11.4266L11.3682 11.1359C10.8539 11.0427 10.5502 10.5865 10.7191 10.161C10.8544 9.82035 11.2536 9.60969 11.6705 9.65892L13.6709 9.89512C14.1282 9.94911 14.55 9.67609 14.6132 9.28531C14.6764 8.89454 14.3569 8.53398 13.8997 8.47999L12.6511 8.33256Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43993_364076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
export default RefundOutlineIcon;